export default __webpack_public_path__ + "static/impact-ready-shadow-mobile-e701f4d1da0fd6a1a225127414c0fadd.svg";